"use strict";

exports.__esModule = true;
exports.formatDate = void 0;
var _momentTimezone = _interopRequireDefault(require("moment-timezone"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var formatDate = exports.formatDate = function formatDate(date, timezone, date_format) {
  if (timezone) return (0, _momentTimezone["default"])(date).tz(timezone.name).format(date_format);
  return (0, _momentTimezone["default"])(date).format(date_format);
};